export let Industry;

(function (Industry) {
  Industry["MarketingAndAdvertising"] = "marketing-and-advertising";
  Industry["TechnologyAndServices"] = "information-technology-and-services";
  Industry["ComputerSoftware"] = "computer-software";
  Industry["RealEstate"] = "real-estate";
  Industry["FinancialServices"] = "financial-services";
  Industry["HealthWellnessAndFitness"] = "health-wellness-and-fitness";
  Industry["Education"] = "education-management";
  Industry["Consulting"] = "management-consulting";
  Industry["Retail"] = "retail";
})(Industry || (Industry = {}));

export let GSWHIndustry;

(function (GSWHIndustry) {
  GSWHIndustry["MarketingAndAdvertising"] = "marketing-and-advertising";
  GSWHIndustry["TechnologyAndServices"] = "technology-and-services";
  GSWHIndustry["RealEstate"] = "real-estate";
  GSWHIndustry["FinancialServices"] = "financial-services";
  GSWHIndustry["HealthWellnessAndFitness"] = "health-wellness-and-fitness";
  GSWHIndustry["Education"] = "education";
  GSWHIndustry["Consulting"] = "consulting";
  GSWHIndustry["Retail"] = "retail";
  GSWHIndustry["Construction"] = "construction";
})(GSWHIndustry || (GSWHIndustry = {}));

export const IndustryOptions = Object.values(Industry);
export const GSWHIndustryOptions = Object.values(GSWHIndustry);